module.exports = "https://bin.bnbstatic.com/_next/static/images/chz-banner-cn-34f80edb15744b9f81e66c6b9ebb2a85.jpg";